import React from 'react';
import { useParams, usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import sectionList from '@/constants/sectionList';
import { getImageUrl } from '@/utils/string';
import { useSelector } from 'react-redux';
import { imageTypes } from '@/constants/types';
import { CAMPAIGN_LANDING } from '@/constants';
import SectionCTA from './SectionCTA';
import TitleWithTimer from './TitleWithTimer';
import ImageComponentV2 from '../Image/ImageComponentV2';

function CampaignSectionHeader({
  uiComponentName,
  sectionId,
  sectionContentType,
  sectionTitle,
  sectionRedirectUrl = {},
  buttonTitle = 'View All',
  hideButton = false,
  targetStartDate,
  targetEndDate,
  topIcon = false,
  showCountDownTimer = false,
  showForFlashSale = false,
  buttonOnly = false,
  className = '',
  mainTitleClassName = false,
}) {
  const { lang } = useSelector((state) => state.globalSettings);
  const hasRedirectUrl =
    sectionRedirectUrl[lang]?.text && sectionRedirectUrl[lang]?.url;
  const { slug } = useParams();
  const pathname = usePathname();

  const isCampaignLanding = pathname.startsWith(CAMPAIGN_LANDING);

  return (
    <div
      className={cn(
        'campaign-section-header',
        showForFlashSale && !topIcon && 'pt-40',
        {
          'pb-20 lg:pb-24': slug,
        },
        className,
      )}
    >
      <div
        className={cn(
          'flex items-center',
          topIcon && 'justify-between',
          !topIcon && 'justify-end',
        )}
      >
        {topIcon &&
        uiComponentName !== sectionList.CAMPAIGN_CATEGORY_PRODUCT_CAROUSEL ? (
          <div className="w-[100px] lg:w-[170px] h-[100px] lg:h-[170px] relative">
            <ImageComponentV2
              src={topIcon ? getImageUrl(topIcon) : null}
              alt={sectionTitle}
              className="w-[100px] h-[100px] lg:w-[170px] lg:h-[170px] object-contain object-center"
              type={imageTypes.square}
              width={170}
              height={170}
              loading="lazy"
            />
          </div>
        ) : null}
      </div>
      <div
        className={cn(
          'lg:flex justify-between items-center gap-[8px]',
          !isCampaignLanding && 'lg:gap-0',
        )}
      >
        <TitleWithTimer
          sectionId={sectionId}
          sectionContentType={sectionContentType}
          sectionTitle={sectionTitle}
          sectionRedirectUrl={sectionRedirectUrl}
          title={sectionTitle}
          hasTimer={showCountDownTimer}
          buttonTitle={buttonTitle}
          buttonOnly={buttonOnly}
          hideButton={hideButton || !hasRedirectUrl}
          showForFlashSale={showForFlashSale}
          // hasIcon={uiComponentName === sectionList.CAMPAIGN_CATEGORY_PRODUCT_CAROUSEL}
          showCountDownTimer={showCountDownTimer}
          targetStartDate={targetStartDate}
          targetEndDate={targetEndDate}
          isCampaignLanding={isCampaignLanding}
          className={cn('flex', mainTitleClassName && 'w-full justify-between')}
        />
        <SectionCTA
          sectionId={sectionId}
          sectionContentType={sectionContentType}
          sectionTitle={sectionTitle}
          sectionRedirectUrl={sectionRedirectUrl}
          title={sectionTitle}
          hasTimer={showCountDownTimer}
          buttonTitle={buttonTitle}
          buttonOnly={buttonOnly}
          hideButton={hideButton || !hasRedirectUrl}
          showForFlashSale={showForFlashSale}
          // hasIcon={uiComponentName === sectionList.CAMPAIGN_CATEGORY_PRODUCT_CAROUSEL}
          className={cn('flex', mainTitleClassName)}
        />
      </div>
    </div>
  );
}

export default CampaignSectionHeader;
